import React from 'react';
import { useSelector } from 'react-redux';

import { Fab } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import AddIcon from '@material-ui/icons/Add';

import {
  Helmet,
  useModulesManager,
  useTranslations,
  useHistory,
  withTooltip,
} from '@stssocialst-stp/fe-core';
import {
  MODULE_NAME,
  PAYROLL_PAYROLL_ROUTE,
  RIGHT_PAYROLL_CREATE,
  RIGHT_PAYROLL_SEARCH,
} from '../../constants';
import PayrollSearcher from '../../components/payroll/PayrollSearcher';

const useStyles = makeStyles((theme) => ({
  page: theme.page,
  fab: theme.fab,
}));

function PayrollsPage() {
  const modulesManager = useModulesManager();
  const classes = useStyles();
  const history = useHistory();
  const rights = useSelector((store) => store.core.user.i_user.rights ?? []);
  const { formatMessage } = useTranslations(MODULE_NAME, modulesManager);

  const onCreate = () => history.push(
    `/${modulesManager.getRef(PAYROLL_PAYROLL_ROUTE)}`,
  );

  return (
    <div className={classes.page}>
      <Helmet title={formatMessage('payroll.page.title')} />
      {rights.includes(RIGHT_PAYROLL_SEARCH)
        && <PayrollSearcher />}
      {rights.includes(RIGHT_PAYROLL_CREATE)
        && withTooltip(
          <div className={classes.fab}>
            <Fab color="primary" onClick={onCreate}>
              <AddIcon />
            </Fab>
          </div>,
          formatMessage('tooltip.createButton'),
        )}
    </div>
  );
}

export default PayrollsPage;
